import { IWorkflowNode } from "motw_core/Entity/IWorkflowNode";
import { fromOthersNodeName, homeNode } from "motw_core/Repositories/WorkflowRepository";
import { WithAnimatedProgressBarAsync } from "source/app/presentation/Header/ProgressBar/LevelProgressBar/WithAnimatedProgressBar";
import MotwLogicServer from "source/app/services/External/LogicServer/MotwLogicServer";

export async function CanReadInBookOfMindAsync(rootNode: IWorkflowNode) {
    if (rootNode.id === homeNode.id) {
        return false;
    }

    const breadCrumbs = await WithAnimatedProgressBarAsync(() =>
        MotwLogicServer.GetPathToHomeNodeAsync(rootNode.id)
    );

    return breadCrumbs.some((node) => node.name === fromOthersNodeName);
}
